import React from 'react'
import Manager from '../../public/components/Manager'
import ForgetSwipeCardApplyDetail from './ForgetSwipeCardApplyDetail'
import LeaveApplyDetail from '../LeaveManagement/LeaveApplyDetail'
import AbnormalAttendanceList from './AbnormalAttendanceList'
Ext.require('Ext.Toast')

const DeleteCheckRecord = (id, refreshPage) => {
    Tyan.pubForm.showConfirm('确定要删除？',
        () => Tyan.doPostEvent('DeleteCheckRecord', {
            data: { id },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('操作成功')
                    refreshPage && refreshPage()
                }
            }
        })
    )
}

const config = {
    tabs: {
        '未处理': {
            buttons: [
            ],
            columns: [
                { _date: '日期', field: 'CheckDate', minWidth: 250, filter: true, align: 'left' },
                { _text: '姓名', field: 'PersonName', minWidth: 150, search: true },
                { _datetime: '签到时间', field: 'CheckInTime', minWidth: 150, flex: 5, align: 'left' },
                { _datetime: '签退时间', field: 'CheckOutTime', minWidth: 150, flex: 5, align: 'left' },
                { _int: '未打卡次数', field: '_NoPunchPeopleNum', minWidth: 150, },
                { _text: '类别', field: '_Type', minWidth: 150, },
                { _: 'forgetSwipeCardApplyID', field: 'ForgetSwipeCardApply.ForgetSwipeCardApplyID' },
                { _: 'outApplyID', field: 'OutApply.OutApplyID' },
                { _: 'bDelete', field: '_bDelete' },
                {
                    _button: '忘刷卡申请...', icon: 'book', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
                        showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={data.forgetSwipeCardApplyID} checkRecordID={data.id} notSubmit={true} />)
                    }
                },
                {
                    _button: '请假申请...', icon: 'book', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
                        showDetail(props => <AbnormalAttendanceList {...props} id={data.outApplyID} checkRecordID={data.id} notSubmit={true} showDetail={showDetail} />)
                    }
                },
                {
                    _button: '删除', icon: 'trash-o', minWidth: 150, hidden: (data) => !data.bDelete,
                    handler: ({ showDetail, refreshPage }, data) => DeleteCheckRecord(data.id, refreshPage)
                },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
            }
        },
        '本月异常考勤': {
            buttons: [
            ],
            columns: [
                { _date: '日期', field: 'CheckDate', minWidth: 250, filter: true, align: 'left' },
                { _text: '姓名', field: 'PersonName', minWidth: 150, search: true },
                { _datetime: '签到时间', field: 'CheckInTime', minWidth: 150, flex: 5, align: 'left' },
                { _datetime: '签退时间', field: 'CheckOutTime', minWidth: 150, flex: 5, align: 'left' },
                { _int: '未打卡次数', field: '_NoPunchPeopleNum', minWidth: 150, },
                { _text: '类别', field: '_Type', minWidth: 150, },
                { _: 'forgetSwipeCardApplyID', field: 'ForgetSwipeCardApply.ForgetSwipeCardApplyID' },
                { _: 'outApplyID', field: 'OutApply.OutApplyID' },
                { _: 'bDelete', field: '_bDelete' },
                {
                    _button: '忘刷卡申请...', icon: 'book', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
                        showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={data.forgetSwipeCardApplyID} checkRecordID={data.id} notSubmit={true} />)
                    }
                },
                {
                    _button: '请假申请...', icon: 'book', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
                        showDetail(props => <LeaveApplyDetail {...props} id={data.outApplyID} checkRecordID={data.id} notSubmit={true} />)
                    }
                },
                {
                    _button: '删除', icon: 'trash-o', minWidth: 150, hidden: (data) => !data.bDelete,
                    handler: ({ showDetail, refreshPage }, data) => DeleteCheckRecord(data.id, refreshPage)
                },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
            }
        },
        '全部': {
            buttons: [
            ],
            columns: [
                { _date: '日期', field: 'CheckDate', minWidth: 250, filter: true, align: 'left' },
                { _text: '姓名', field: 'PersonName', minWidth: 150, search: true },
                { _datetime: '签到时间', field: 'CheckInTime', minWidth: 150, flex: 5, align: 'left' },
                { _datetime: '签退时间', field: 'CheckOutTime', minWidth: 150, flex: 5, align: 'left' },
                { _int: '未打卡次数', field: '_NoPunchPeopleNum', minWidth: 150, },
                { _text: '类别', field: '_Type', minWidth: 150, },
                { _: 'forgetSwipeCardApplyID', field: 'ForgetSwipeCardApply.ForgetSwipeCardApplyID' },
                { _: 'outApplyID', field: 'OutApply.OutApplyID' },
                { _: 'bDelete', field: '_bDelete' },
                {
                    _button: '忘刷卡申请...', icon: 'book', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
                        showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={data.forgetSwipeCardApplyID} checkRecordID={data.id} readOnly={true} notSubmit={true} />)
                    }, hidden: (data) => data.forgetSwipeCardApplyID == 0
                },
                {
                    _button: '请假申请...', icon: 'book', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
                        showDetail(props => <LeaveApplyDetail {...props} id={data.outApplyID} checkRecordID={data.id} notSubmit={true} readOnly={true} />)
                    }, hidden: (data) => data.outApplyID == 0
                },
                {
                    _button: '删除', icon: 'trash-o', minWidth: 150, hidden: (data) => !data.bDelete,
                    handler: ({ showDetail, refreshPage }, data) => DeleteCheckRecord(data.id, refreshPage)
                },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
            }
        },
    }
}

export default props => <Manager {...props} config={config} />